module.exports = __webpack_public_path__ + "img/sms_confirmation.c1a83a55.svg";